import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=4a5358e6&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=4a5358e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5358e6",
  null
  
)

export default component.exports